import { useMemo } from 'react';
import { APIPageQueryOptions } from 'shared/api/APIPageQuery';
import { useInsurance } from 'shared/modules/carrier-profile/data/CarrierProfileAPI';
import { CargoInsuranceDTO } from 'shared/modules/carrier-profile/data/CarrierProfileDTO';

export function useInsurances(
  options?: APIPageQueryOptions<CargoInsuranceDTO>,
) {
  const { data, isInitialLoading, isError } = useInsurance(options);
  return useMemo(() => {
    const currentInsurance = data?.data.find(
      (insurance) => insurance.is_current,
    );
    const renewalInsurance = data?.data.find(
      (insurance) => !insurance.is_current,
    );

    return { isInitialLoading, currentInsurance, renewalInsurance, isError };
  }, [data, isInitialLoading, isError]);
}
